// @flow
import camelCase from 'lodash.camelcase';
import isEqual from 'lodash.isequal';
import { prop } from './functions';
import { option, type Option } from 'fp-ts';
import _get from 'lodash.get';

export const get = (property: string) => (obj: Object) => obj[property];

export const getPath = ([...props]: Array<string | any>) => (obj: Object) => props.reduce((accum, prop): any =>
  (accum === undefined ? false : accum[prop])
  , obj);

export const objKeysCamelCase = (obj: Object) => Object.keys(obj)
  .reduce((acc, key) => ({ ...acc, [camelCase(key)]: obj[key] }), {});

export const optionGet = (p: string) => (obj: ?Object): Option<any> => option.fromNullable(_get(obj, p, undefined));

// Takes two objects and returns an array of keys that have different values in each object.
export const compareObjects = (o1: Object) => (o2: Object) => (
  Object.entries(o1).reduce((result, [key, value]: [string, any]) => (
    !isEqual(value, o2[key]) ? [...result, key] : result
  ), [])
);

// given a list of properties to check for changes, return an array of tuples of the shape [didChange, value]
export const compareObjectsToTuple = (propsToTest: Array<string>) => (sourceObject: Object) => (newObject: Object): Array<[string, boolean, any]> => {
  const changes = compareObjects(sourceObject)(newObject).filter(x => propsToTest.includes(x));
  return propsToTest.map(x => [x, changes.includes(x), prop(x)(newObject).getOrElseValue(false)]);
};
export const isPathString = (x: String) => x.charAt(0) === '{' && x.charAt(x.length - 1) === '}';
export const isDynamicValue = (x: mixed) => typeof x === 'string' && isPathString(x);
export const getDynamicValue = (x: string) => (y: Object) => optionGet(x.replace('{', '').replace('}', ''))(y).getOrElseValue('');
export const runFnForObject = (objectHandler: Function) => (x: mixed) => (y: Object) => (typeof x === 'object' ? objectHandler(x)(y) : x);

// Given an object of arbitrary depth that includes values that are paths to the data source object,
// return an object populated with the data from the source object
export const buildObjectFromPaths = (objectWithPaths: Object) => (dataSource: Object): Object => (
  Object.entries(objectWithPaths).reduce((result, [key, value]) => ({
    ...result,
    [key]: isDynamicValue(value) ? getDynamicValue(value)(dataSource) : runFnForObject(buildObjectFromPaths)(value)(dataSource),
  }), {})
);

export const getFirstKeyedObject = (object: Object) => object[Object.keys(object).shift()];



// WEBPACK FOOTER //
// ./src/helpers/objects.js